import { HeaderControls, HeaderModule } from 'components/header/anand.header';
import { mountDateTimeField } from 'components/DateTimeField';
import { createRecordAutocomplete } from './recordAutocomplete';
import { ssnDefaultExpiryKey, ssnDefaultPublishKey, ssnStartingCardKey } from 'config';
import { ModelClass } from 'core/anand.model';
import { notification } from 'core/anand.notification';
import { overlay_panel } from 'core/anand.overlay_panel';
import { Records } from 'core/anand.records';
import { utils as Utils } from 'core/anand.utils';
import { setRecord } from 'fb';
import { getDownloadUrl } from 'fb/storage';
import { getUserPermissionsHelper, isAdmin, timeout } from 'helpers';
import AnandDate from 'helpers/AnandDate';
import { copyTextToClipboard } from 'helpers/clipboard';
import { isValidMobileNumber, normalizeMobileNumber } from 'helpers/mobileNumber';
import { capitalizeName } from 'helpers/nameCase';
import { parseDateTime } from 'helpers/parseDateTime';
import { isCardShared, markCardShared, shareAnumatiCard } from 'helpers/shareCard';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { store } from 'store';
import { ApplicationState } from 'types';
import { v1 as uuidv1 } from 'uuid';
import firebase from '../../fb/initconfig';
const numWords = require('num-words');

export const AnumatiPatra = (function ($) {
	let recordAutocomplete: ReturnType<typeof createRecordAutocomplete> | undefined;
	var configMap = {
		publication: {
			name: 'Anumati Patra',
		},
		lastPrintedRecordId: '--last-prnted--',
		startDate: new Date('2025-03-01'),
		startingCardKey: ssnStartingCardKey,
	};

	var stateMap: any = {
		systemId: 'anumati',
		lastPrinted: 0,
		refFilter: [],
		pinnedTiles: {},
		dateFilter: [],
		checkinDateFilter: [],
	};

	function printHtml(e?, records?) {
		Records.refreshRecordsAndReposition();

		var printConfigHtml = `<div id="print-configs">
								<div class="col-xs-12">
									<label class="checkbox" style="display:inline;padding:1em">
										<input style="width:auto" type="checkbox" class="complete-card" />
										Print Complete Card
									</label>
									<label class="checkbox" style="display:inline;padding:1em">
										<input style="width:auto" type="checkbox" class="auto-mark-printed" />
										Auto Mark as Printed
									</label>
								</div>`;

		var printBtnHtml = `
			<button id="print_records_btn" class="button btn btn-primary">
				<span><span>Print</span></span>
			</button>
			<button id="mark_printed_records_btn" class="button btn btn-primary">
				<span><span>Mark Printed</span></span>
			</button>
			<!-- <button id="send_sms_records_btn" class="button btn btn-primary">
				<span><span>Send SMS</span></span>
			</button> -->
			<button id="send_ams_records_btn" class="button btn btn-primary">
				<span><span>Send AMS</span></span>
			</button>
		`;

		printConfigHtml += '<iframe id="print-preview" name="print-preview" src="about:blank"></iframe>';
		printConfigHtml += '</div>';

		var printConfigObj = {
			contentHtml: printConfigHtml,
			id: 'print_config',
			title: 'Print Card',
			headerBtnHtml: printBtnHtml,
		};

		overlay_panel.showPanel(printConfigObj);

		$('#print-configs select').on('change', () => {
			updatePrintPreview(null, false, false, records);
		});
		$('#print-configs input').on('change', () => {
			updatePrintPreview(null, false, false, records);
		});

		$('#print_records_btn').click(function () {
			updatePrintPreview(null, true, false, records);
		});

		$('#mark_printed_records_btn').click(function () {
			markAsPrinted(records);
		});

		$('#send_sms_records_btn').click(() => {
			sendSMSToAll(records);
		});

		$('#send_ams_records_btn').click(() => {
			sendAMSToAll(records);
		});

		updatePrintPreview(null, false, false, records);
	}

	function getSelectedPrintConfigs() {
		var printConfigs = {
			completeCard: $('.complete-card').is(':checked'),
			autoMarkPrinted: $('.auto-mark-printed').is(':checked'),
			headers: [],
		};

		return printConfigs;
	}

	async function sendAMSToAll(records?) {
		let allRecords: any[] = records ? records : Records.getCurrentRecords();

		for (let i = 0; i < allRecords.length; i++) {
			let record = allRecords[i];

			await timeout(10);
			await sendAMS(record);
		}

		Records.refreshRecords();
		notification.showBottomNotification(`AMS request sent for ${allRecords.length} records`);
	}

	async function sendSMSToAll(records?) {
		let allRecords: any[] = records ? records : Records.getCurrentRecords();
		let smsindex = 0;

		markOneSMS(allRecords[smsindex]);

		async function markOneSMS(record) {
			await timeout(10);

			sendSMS(record, (response) => {
				if (smsindex < allRecords.length - 1) {
					markOneSMS(allRecords[++smsindex]);
				} else {
					Records.refreshRecords();
					notification.showBottomNotification(`AMS request sent for ${allRecords.length} records`);
				}
			});
		}
	}

	function markAsPrinted(records?) {
		let allRecords: any[] = records ? records : Records.getCurrentRecords();
		let markindex = 0;

		markRecord(allRecords[markindex]);

		function markRecord(record) {
			record.card_printed = true;

			let Model = ModelClass.Instance(stateMap.systemId);
			Model.editRecord({ card_printed: true }, record.id, () => {
				if (markindex < allRecords.length - 1) {
					markRecord(allRecords[++markindex]);
				} else {
					Records.refreshRecords();
				}
			});
		}
	}

	function updatePrintPreview(e, autoPrint?, exportRecords?, records?) {
		var data: any[];
		if (records) {
			data = JSON.parse(JSON.stringify(records));
		} else {
			data = JSON.parse(JSON.stringify(Records.getCurrentRecords()));
		}

		if (typeof autoPrint === 'undefined' || autoPrint === false) {
			data = data.slice(0, 1);
		}

		var configs = getSelectedPrintConfigs();

		var headerHtml = '';
		var footerHtml = '<footer></footer>';

		var headHtml = `
			<head>
				<style>	
					body {
						margin: 0;
					}					
					.print-top-div {
						background-color: white;
						padding: 0px;
						width: 148mm;
						position: relative;
						height: 209.8mm;
						font-family: helvetica;
					}

					.print-record {
						height: 100%;
					}
					
					@media print {
						.print-top-div footer {
							page-break-after: always;
						}
					}

					.print-top-div footer {
						position: absolute;
						bottom: 0px;
						padding: 0px;
						right: 0px;
						left: 0px;
						page-break-after: always;
					}

					.print-top-div footer > div {
						padding: 0;
					}

					.print-top-div img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}

					.print-top-div .card-no {
						position: absolute;
						top: 62px;
						left: 106px;
						font-size: 1.3em;
					}

					.print-top-div .name {
						position: absolute;
						top: 158px;
						left: 106px;
						font-size: 1.3em;
						font-weight: bold;
					}

					.print-top-div .card-date {
						position: absolute;
						top: 260px;
						left: 135px;
						font-size: 1.3em;
						text-decoration: underline;
					}

					.print-top-div .card-count {
						position: absolute;
						top: 260px;
						left: 335px;
						font-size: 1.2em;
						width: 120px;
						text-align: center;
						text-transform: capitalize;
						text-decoration: underline;
					}
				</style>
			</head>
		`;
		// '<head>' +
		// '<link rel="stylesheet" type="text/css" href="/application/themes/anand/assets/css/lib/bootstrap/bootstrap.css">' +
		// '<link rel="stylesheet" type="text/css" href="/application/modules/kutiya_records/assets/css/anand.kutiyaRecords.print.css">' +
		// '</head>';
		var html = headHtml + '<body>';

		for (var i = 0; i < data.length; i++) {
			html += '<div class="print-top-div">' + printOneRecord(data[i]) + '</div>';
		}

		html += '</div></body>';

		function printOneRecord(record) {
			for (var key in record) {
				if (record[key] == null || record[key] == '') {
					record[key] = '&nbsp';
				}
			}

			var html = `
				${headerHtml}
				<div class='print-record'>
					${configs.completeCard ? `<img src="${stateMap.cardBase64}" />` : ''}
					<div class='card-no'>
						${record.card_no}
					</div>
					<div class='name'>
						${record.name}
					</div>
					<div class='card-date'>
						${new AnandDate(record.permission_date).format('DD/MM/YYYY')}
					</div>
					<div class='card-count'>
						${numWords(record.people_count)}
					</div>
					${footerHtml}
				</div>
			`;

			return html;
		}

		var iFrameWindow = window.frames['print-preview'];
		var doc = iFrameWindow.document;
		$('body', doc).html(html);

		// $('body', doc).find('.print-top-div').css('font-size', configs.font_size);
		// $('body', doc).find('.print-top-div').css('font-family', configs.font_type);

		$('#print-preview').css('height', '210mm');

		if (typeof autoPrint !== 'undefined' && autoPrint === true) {
			if (configs.autoMarkPrinted) {
				markAsPrinted(records);
			}

			iFrameWindow.focus();
			iFrameWindow.print();
		}
	}

	function initModule(props?, updateRecordsState?) {
		let permissions = getUserPermissionsHelper(store, stateMap.systemId);
		recordAutocomplete?.dispose();
		recordAutocomplete = createRecordAutocomplete({
			getSnapshot: () => {
				const state = store.getState();
				const signedIn = !!state.dataState.userStore.user;
				return {
					history: signedIn && getUserPermissionsHelper(store, 'anumati').viewAllowed ?
						state.dataState.anumati.filtered : null,
					directory: signedIn && getUserPermissionsHelper(store, 'mjbj').viewAllowed ?
						state.dataState.mjbj.filtered : null,
					session: state.dataState.userStore,
				};
			},
			subscribe: (listener) => store.subscribe(listener),
			loadImage: (image) => getDownloadUrl('mjbj/images/' + image),
		});

		// Exposed on stateMap because the detail tile is built outside this scope and the
		// add form's visibility is driven by React state, not jQuery alone.
		stateMap.toggleForm = () => props?.props?.toggleForm?.();

		($.validator as any)?.addMethod(
			'mobileNumber',
			function (value, element) {
				return this.optional(element) || isValidMobileNumber(value);
			},
			'Enter a 10 digit mobile number, or include the country code (e.g. +44...) for other countries'
		);

		// Delegated so it covers both add forms, including the one built on demand.
		$(document)
			.off('click.anumatiCopyPhone')
			.on('click.anumatiCopyPhone', '.copy-phone-btn', async function (e) {
				e.preventDefault();
				e.stopPropagation();

				let phone = $.trim($(this).closest('.phone-detail').find("input[name='phone']").val() as string);

				if (!phone) {
					notification.showBottomNotification('No mobile number to copy');
					return;
				}

				let copied = await copyTextToClipboard(phone);
				notification.showBottomNotification(copied ? 'Mobile number copied: ' + phone : 'Could not copy mobile number');
			});

		$(document)
			.off('input.anumatiPhoneValidity change.anumatiPhoneValidity')
			.on('input.anumatiPhoneValidity change.anumatiPhoneValidity', 'form input[name="phone"]', function () {
				refreshPhoneValidity($(this));
			});

		// Delegated because the date wise count table is rebuilt on every refresh.
		$(document)
			.off('change.anumatiCountFilter')
			.on('change.anumatiCountFilter', '#date_wise_count .date-filter-check, #date_wise_count .checkin-filter-check', function () {
				let checkbox = $(this);
				let date = checkbox.attr('data-date');
				let isCheckinFilter = checkbox.hasClass('checkin-filter-check');
				let selected: string[] = isCheckinFilter ? stateMap.checkinDateFilter : stateMap.dateFilter;

				selected = selected.filter((selectedDate) => selectedDate !== date);
				if (checkbox.is(':checked') && date) {
					selected.push(date);
				}

				if (isCheckinFilter) {
					stateMap.checkinDateFilter = selected;
				} else {
					stateMap.dateFilter = selected;
				}

				Records.refreshRecords();
			});

		let toggleDetailCountBtn = $(`
		<a class="btn toggle-counts-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-eye-open"></span>
			<span class="hidden-sm hidden-xs menu-text">Counts</span>
		</a>`);
		toggleDetailCountBtn.click(props.props?.toggleDetailCount);

		let toggleFormBtn = $(`
		<a class="btn toggle-counts-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-eye-open"></span>
			<span class="hidden-sm hidden-xs menu-text">Form</span>
		</a>`);
		toggleFormBtn.click(props.props?.toggleForm);

		let toggleDetailedViewBtn = $(`
		<a class="btn toggle-detailed-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-eye-open"></span>
			<span class="hidden-sm hidden-xs menu-text">Detailed</span>
		</a>`);
		toggleDetailedViewBtn.click(props.props?.toggleShowDetailed);

		/**
		 * On a phone the three toggles above are three identical eye icons with no labels,
		 * which is pure guesswork. They are replaced by one eye that opens a labelled sheet,
		 * where each entry also shows whether it is currently on.
		 */
		let viewMenu = $(`
		<span class="view-dropdown dropdown visible-xs-inline-block visible-sm-inline-block">
			<a class="btn view-btn dropdown-toggle" data-toggle="dropdown" title="What to show">
				<span class="glyphicon glyphicon-eye-open"></span>
			</a>
			<ul class="dropdown-menu">
				<li class="dropdown-header">What to show</li>
				<li><a class="btn view-option" data-view="counts">
					<span class="glyphicon glyphicon-ok view-state"></span>
					<span class="menu-text">Date wise counts</span>
				</a></li>
				<li><a class="btn view-option" data-view="detailed">
					<span class="glyphicon glyphicon-ok view-state"></span>
					<span class="menu-text">Detailed tiles</span>
				</a></li>
				<li class="view-form-option"><a class="btn view-option" data-view="form">
					<span class="glyphicon glyphicon-ok view-state"></span>
					<span class="menu-text">Add record form</span>
				</a></li>
			</ul>
		</span>`);

		if (!permissions.editAllowed) {
			viewMenu.find('.view-form-option').remove();
		}

		/** Reads the live state, so the ticks cannot drift from what is on screen. */
		function refreshViewMenuState() {
			let states = props.props?.getViewState?.() ?? {
				counts: $('#date_wise_count').is(':visible'),
				form: $('#anumati-add-record-open').is(':visible'),
				detailed: false,
			};

			viewMenu.find('.view-option').each(function () {
				let option = $(this);
				let on = !!states[option.attr('data-view') ?? ''];
				option.toggleClass('view-on', on);
				option.find('.view-state').css('visibility', on ? 'visible' : 'hidden');
			});
		}

		viewMenu.on('show.bs.dropdown', refreshViewMenuState);

		viewMenu.find('.view-option').on('click', function (event) {
			// Bootstrap closes a dropdown on any document click. These are toggles, so the
			// sheet stays open and updates in place, letting several be changed at once.
			event.preventDefault();
			event.stopPropagation();

			switch ($(this).attr('data-view')) {
				case 'counts':
					props.props?.toggleDetailCount?.();
					break;
				case 'detailed':
					props.props?.toggleShowDetailed?.();
					break;
				case 'form':
					props.props?.toggleForm?.();
					break;
			}

			// React state lands on the next tick, so the ticks are refreshed after it.
			setTimeout(refreshViewMenuState, 0);
		});

		// These three open wide, table heavy dialogs that cannot be used on a phone, so
		// they are desktop only, the same way Print already is.
		let bulkEditBtn = $(`
		<a class="btn toggle-counts-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-pencil"></span>
			<span class="hidden-sm hidden-xs menu-text">Bulk Edit</span>
		</a>`);
		bulkEditBtn.click(props.props?.bulkEdit);

		let exportBtn = $(`
		<a class="btn toggle-counts-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-download-alt"></span>
			<span class="hidden-sm hidden-xs menu-text">Export</span>
		</a>`);
		exportBtn.click(props.props?.exportRecords);

		let importBtn = $(`
		<a class="btn toggle-counts-btn hidden-sm hidden-xs">
			<span class="glyphicon glyphicon-open"></span>
			<span class="hidden-sm hidden-xs menu-text">Import</span>
		</a>`);
		importBtn.click(props.props?.importRecords);

		let modules = [HeaderControls.selectDropdown, HeaderControls.sortBtn, viewMenu, toggleDetailCountBtn, toggleDetailedViewBtn];

		if (permissions.editAllowed) {
			modules.push(toggleFormBtn);
		}

		let admin = isAdmin(store.getState().dataState.userStore.userData);
		if (admin) {
			modules.push(bulkEditBtn);
			modules.push(exportBtn);
			modules.push(importBtn);
			// } else {
			// 	$('#anumati-add-record-open .publish-detail').hide();
			// 	$('#anumati-add-record-open .expire-detail').hide();
		}

		HeaderModule.initModule(modules, true);

		($.fn as any).intlTelInput.loadUtils('/assets/js/lib/IntlTelInput/utils.js');
		Utils.toDataURL('/assets/img/card.jpg').then((dataUrl) => {
			stateMap.cardBase64 = dataUrl;
		});

		Records.projectTitle = 'Anumati Patra';

		Records.getAnySearchFilter = getAnySearchFilter;
		Records.defaultSortOrder = 'createdTime logicaldesc';
		Records.IdentifyingFieldName = 'id';
		Records.imageFieldName = null;

		Records.updateRecordsState = updateRecordsState;

		/**
		 * Approval sorts by how much attention a card needs, not alphabetically.
		 *
		 * Alphabetical order put Rejected and Approved either side of Pending, burying the
		 * requests that actually need a decision. Requests awaiting a decision come first,
		 * then rejected ones, then issued cards.
		 */
		const APPROVAL_PRIORITY = { Pending: 0, Rejected: 1, Blocked: 2, Approved: 3 };
		const UNKNOWN_APPROVAL_PRIORITY = 2;

		function approvalPriority(record) {
			// A record with no approval is a request only if no card was ever issued.
			let status = record?.approval?.status ?? (record?.card_no ? 'Approved' : 'Pending');
			return APPROVAL_PRIORITY[status] ?? UNKNOWN_APPROVAL_PRIORITY;
		}

		Records.customSortingFunction = (title, sortDir) => {
			switch (title) {
				case 'Approval':
					return (a, b) => {
						let result = approvalPriority(a) - approvalPriority(b);
						result = result || (a.card_no ?? 0) - (b.card_no ?? 0) || a.createdTime - b.createdTime;

						return sortDir * result;
					};
			}
		};

		Records.sortingFieldsMap = {
			'card_no, createdTime': 'Card No',
			name: 'Name',
			permission_date: 'Date',
			reference: 'Ref',
			createdTime: 'Created',
			function: 'Approval',
		};

		Records.searchFieldsMap = {
			card_no: { filter: '==', text: 'Card No' },
			name: 'Name',
			reference: 'Ref',
			permission_date: 'Date',
			byName: 'Created By',
		};

		if (permissions.editAllowed) {
			Records.searchFieldsMap['phone'] = 'Phone';
		}

		Records.searchFieldsMap['checkin'] = { filter: 'has', text: 'Checkins' };
		// Records.searchFieldsMap['publishTime'] = 'Publish Time';
		// Records.searchFieldsMap['expireTime'] = 'Expire Time';

		Records.isSearchDateTypeColumn = function (searchBy) {
			if (searchBy === 'permission_date' || searchBy === 'publishTime' || searchBy === 'expireTime') {
				return true;
			} else {
				return false;
			}
		};

		function getLastPrintedCardNo() {
			let state: ApplicationState = store.getState();
			let records = state.dataState[stateMap.systemId]?.byId ?? {};
			let lastPrintedRecord = records[configMap.lastPrintedRecordId];
			return lastPrintedRecord?.value ?? 0;
		}

		function getLastPrintedPageNo() {
			let state: ApplicationState = store.getState();
			let records = state.dataState[stateMap.systemId]?.byId ?? {};
			let lastPrintedRecord = records[configMap.lastPrintedRecordId];
			return lastPrintedRecord?.lastPrintedPageNo ?? 0;
		}

		function getPrintHistory() {
			let state: ApplicationState = store.getState();
			let records = state.dataState[stateMap.systemId]?.byId ?? {};
			let lastPrintedRecord = records[configMap.lastPrintedRecordId];
			return lastPrintedRecord?.history ?? {};
		}

		function printSummary() {
			Records.refreshRecordsAndReposition();

			var printHistory = getPrintHistory();
			var printHistoryHtml = '';
			var historyTimes = Object.keys(printHistory); //.filter((a) => parseInt(a) > configMap.startDate.getTime());

			var lastPrinted = historyTimes.length ? (stateMap.lastPrinted = getLastPrintedCardNo()) : 0;
			var lastPrintedPageNo = historyTimes.length ? (stateMap.lastPrintedPageNo = getLastPrintedPageNo()) : 0;

			var printConfig = `<div id="print-configs">
									<div class="col-xs-12">
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="with-mobile" />
											With Mobile
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="with-ref" />
											With Ref
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="with-checkins" />
											With Checkins
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="print-portrait" checked />
											Portrait
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="from-prev-print" checked />
											Start after card ${lastPrinted}
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="from-prev-page" checked />
											Start from page <input style="width:50px" type="number" class="from-prev-page-value" value="${lastPrintedPageNo + 1}" />
										</label>
										<label class="checkbox" style="display:inline;padding:1em">
											<input style="width:auto" type="checkbox" class="card-sorted" checked />
											Sort by card no
										</label>
									</div>`;

			if (historyTimes.length) {
				printHistoryHtml = `<div class='print-history'><table>
					<tr>
						<th>Date</th>
						<th>From Card</th>
						<th>To Card</th>
						<th>From Page</th>
						<th>To Page</th>
						<th>Printed By</th>
					</tr>`;

				historyTimes = historyTimes.sort((a, b) => parseInt(b) - parseInt(a));
				for (let i = 0; i < historyTimes.length; i++) {
					let timestamp = historyTimes[i];
					let history = printHistory[timestamp];

					if (history.maxCardNo < stateMap.startingCardNo) {
						continue;
					}

					printHistoryHtml += `<tr>
						<td>${new AnandDate().setEpoch(parseInt(timestamp)).format('ddd Do MMM, YYYY hh:mm:ss A')}</td>
						<td>${history.minCardNo}</td>
						<td>${history.maxCardNo}</td>
						<td>${history.minPageNo}</td>
						<td>${history.maxPageNo}</td>
						<td>${history.by}</td>
					</tr>`;
				}

				printHistoryHtml += '</table></div>';
			}

			printConfig = printHistoryHtml + printConfig;

			var printBtn = '<button id="print_records_btn" class="button btn btn-primary">' + '<span><span>Print</span></span>' + '</button>';

			printConfig += '<iframe id="print-preview" name="print-preview" src="about:blank"></iframe>';
			printConfig += '</div>';

			var printConfigObj = {
				contentHtml: printConfig,
				id: 'print_config',
				title: 'Print Summary',
				headerBtnHtml: printBtn,
				afterAppend: function () {
					updatePrintSummaryPreview(null);
				},
			};

			overlay_panel.showPanel(printConfigObj);

			$('#print-configs select').on('change', updatePrintSummaryPreview);
			$('#print-configs input').on('change', updatePrintSummaryPreview);

			$('#print_records_btn').click(function () {
				updatePrintSummaryPreview(null, true);
			});
		}

		function getSelectedPrintConfigs() {
			var printConfigs = {
				withMobile: $('.with-mobile').is(':checked'),
				withRef: $('.with-ref').is(':checked'),
				withCheckins: $('.with-checkins').is(':checked'),
				portrait: $('.print-portrait').is(':checked'),
				fromPrevPrint: $('.from-prev-print').is(':checked'),
				fromPrevPage: $('.from-prev-page').is(':checked'),
				fromPrevPageValue: parseInt($('.from-prev-page-value').val() as string),
				cardSorted: $('.card-sorted').is(':checked'),
				headers: [],
			};

			return printConfigs;
		}

		/**
		 * Total people checked in against a record, matching how the date wise count table
		 * counts them: only check-ins, including ladies, minors and infants.
		 */
		function getRecordCheckinCount(record) {
			let checkins = record ? record['checkin'] : null;

			if (!Array.isArray(checkins)) {
				return 0;
			}

			return checkins.reduce((count, checkin) => {
				if (!checkin || checkin['in_out'] !== 'in') {
					return count;
				}

				return (
					count +
					(parseInt(checkin['checkin_count'] ?? '0') || 0) +
					(parseInt(checkin['checkin_count_ladies'] ?? '0') || 0) +
					(parseInt(checkin['checkin_count_minor'] ?? '0') || 0) +
					(parseInt(checkin['checkin_count_infant'] ?? '0') || 0)
				);
			}, 0);
		}

		function updatePrintSummaryPreview(e, autoPrint?, exportRecords?) {
			var data: any[] = JSON.parse(JSON.stringify(Records.getCurrentRecords()));
			let configs = getSelectedPrintConfigs();

			if (configs.fromPrevPrint) {
				var lastPrinted = stateMap.lastPrinted;
				data = data.filter((record) => record.card_no > lastPrinted);
			}

			if (configs.cardSorted) {
				data = data.sort((a, b) => a.card_no - b.card_no);
			}

			if (typeof autoPrint === 'undefined') {
				data = data.slice(0, 50);
			}

			let pageOffset = configs.fromPrevPage ? configs.fromPrevPageValue - 1 : 0;

			const pdfDoc = new jsPDF({ orientation: configs.portrait ? 'portrait' : 'landscape' });

			let total = {};
			let checkinTotal = {};

			data.forEach((record) => {
				let date = record.permission_date;
				let members = parseInt(record.people_count ?? '0') || 0;

				total[date] = (total[date] ?? 0) + members;

				// Check-ins share the member cell as "members / check-ins" so that showing
				// them does not add columns to an already wide table.
				if (configs.withCheckins) {
					let checkins = getRecordCheckinCount(record);
					checkinTotal[date] = (checkinTotal[date] ?? 0) + checkins;
					record[date] = members + ' / ' + checkins;
				} else {
					record[date] = members;
				}
			});

			let dates = Object.keys(total)
				.map((date) => ({
					header: new AnandDate(date).format('DD-MM'),
					dataKey: date,
				}))
				.sort((a, b) => (a.dataKey > b.dataKey ? 1 : -1));

			// let total: any = {};

			// data.forEach((record) => {
			// 	record[record.permission_date] = (record[record.permission_date] ?? 0) + record.people_count;
			// 	total[record.permission_date] = (total[record.permission_date] ?? 0) + record.people_count;
			// });

			let sortedTotal: any[] = [];
			dates.forEach((date) => {
				let content = configs.withCheckins
					? total[date.dataKey] + ' / ' + (checkinTotal[date.dataKey] ?? 0)
					: total[date.dataKey];

				sortedTotal.push({ content: content, rowSpan: 1, colSpan: 1 });
			});

			var totalPagesExp = '{total_pages_count_string}';
			let columns = [
				{ header: 'CARD NO.', dataKey: 'card_no' },
				{ header: 'NAME', dataKey: 'name' },
			];
			if (configs.withRef) {
				columns.push({ header: 'REF.', dataKey: 'reference' });
			}
			if (configs.withMobile) {
				columns.push({ header: 'MOBILE', dataKey: 'phone' });
			}

			columns = columns.concat([...dates]);

			autoTable(pdfDoc, {
				theme: 'grid',
				styles: {
					halign: 'center',
				},
				columnStyles: {
					name: { halign: 'left' },
					reference: { halign: 'left' },
				},
				headStyles: {
					fillColor: 'white',
					textColor: 'black',
					lineWidth: 0.3,
					lineColor: [0, 0, 0],
				},
				footStyles: {
					fillColor: 'white',
					textColor: 'black',
					lineWidth: 0.3,
					lineColor: [0, 0, 0],
				},
				bodyStyles: {
					textColor: [0, 0, 0],
					lineWidth: 0.3,
					lineColor: [0, 0, 0],
				},
				// tableLineColor: [0, 0, 0],
				// tableLineWidth: 0.5,
				columns: columns,
				body: data,
				foot: [
					[
						{
							content: configs.withCheckins ? 'TOTAL MEMBERS / CHECKINS' : 'TOTAL MEMBERS',
							colSpan: 2 + (configs.withMobile ? 1 : 0) + (configs.withRef ? 1 : 0),
							rowSpan: 1,
						},
						...sortedTotal,
					],
				],
				showFoot: 'lastPage',
				// margin: { bottom: 0 },
				didDrawPage: (data) => {
					var pageSize = pdfDoc.internal.pageSize;
					var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
					var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

					// Header
					// pdfDoc.setFontSize(16);
					// pdfDoc.setTextColor(40);

					// let ssn = 'SHRI SANT NAGAR';
					// let dim = pdfDoc.getTextDimensions(ssn);
					// pdfDoc.text(ssn, (pageWidth - dim.w) / 2, 10);

					// Footer
					var str = 'Page ' + (data.pageNumber + pageOffset); //pdfDoc.internal.getNumberOfPages();
					// Total page number plugin only available in jspdf v1.0+
					// if (typeof pdfDoc.putTotalPages === 'function') {
					// 	str = str + ' of ' + (totalPagesExp + (configs.fromPrevPage ? stateMap.lastPrintedPageNo : 0));
					// }
					pdfDoc.setFontSize(10);

					let bottom = pageHeight - data.settings.margin.bottom + 5;
					pdfDoc.text(str, data.settings.margin.left, bottom);

					let ssn = 'SHRI SANT NAGAR';
					let dim = pdfDoc.getTextDimensions(ssn);
					pdfDoc.text(ssn, (pageWidth - dim.w) / 2, bottom);

					let dateStr = new AnandDate().format('ddd, Do MMM, YYYY');
					dim = pdfDoc.getTextDimensions(dateStr);
					pdfDoc.text(dateStr, pageWidth - data.settings.margin.left - dim.w, bottom);
				},
			});

			// if (typeof pdfDoc.putTotalPages === 'function') {
			// 	pdfDoc.putTotalPages(totalPagesExp);
			// }

			if (autoPrint === true) {
				pdfDoc.autoPrint();

				const hiddFrame = document.createElement('iframe');
				hiddFrame.style.position = 'fixed';
				// "visibility: hidden" would trigger safety rules in some browsers like safari，
				// in which the iframe display in a pretty small size instead of hidden.
				// here is some little hack ~
				hiddFrame.style.width = '1px';
				hiddFrame.style.height = '1px';
				hiddFrame.style.opacity = '0.01';
				const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
				if (isSafari) {
					// fallback in safari
					hiddFrame.onload = () => {
						try {
							hiddFrame.contentWindow?.document.execCommand('print', false, undefined);
						} catch (e) {
							hiddFrame.contentWindow?.print();
						}
					};
				}
				hiddFrame.src = pdfDoc.output('bloburl').toString();
				document.body.appendChild(hiddFrame);

				let cardNos = data.map((record) => parseInt(record.card_no));
				stateMap.lastPrinted = Math.max(...cardNos);
				setRecord(stateMap.systemId, configMap.lastPrintedRecordId, {
					value: stateMap.lastPrinted,
					lastPrintedPageNo: pageOffset + pdfDoc.getNumberOfPages(),
					history: {
						[new Date().getTime()]: {
							cardNos: cardNos,
							minCardNo: Math.min(...cardNos),
							maxCardNo: stateMap.lastPrinted,
							minPageNo: pageOffset + 1,
							maxPageNo: pageOffset + pdfDoc.getNumberOfPages(),
							by: firebase.auth().currentUser?.displayName,
						},
					},
				});

				// const blob = pdfDoc.output('bloburl').toString();
				// window.open(blob);

				// var now = new Date();
				// var fileName = 'SSN Summary ' + Utils.formatDate(now) + ' ' + now.toLocaleTimeString();
				// pdfDoc.save(fileName);
			} else {
				var url = pdfDoc.output('datauristring');
				$('#print-preview').attr('src', url);
			}
		}

		Records.hooks.afterHeaderConfigure = async function (controlsHeader) {
			if (Records.editAllowed) {
				var openAddRecordForm: any = $('#anumati-add-record-open');

				setTimeout(() => {
					Records.triggerAddRecord(null, null, openAddRecordForm);
					if (stateMap.defaultPublishValue) {
						let publishDate = new AnandDate(stateMap.defaultPublishValue);
						openAddRecordForm.find("input[name='publishDatePart']").attr('value', publishDate.format('YYYY-MM-DD'));
						openAddRecordForm.find('input[name="publishDatePart"]').datepicker('update', publishDate.getDateObj());
						openAddRecordForm.find("input[name='publishTimePart']").val(publishDate.format('hh:mm:ss A'));
					}
					if (stateMap.defaultExpireValue) {
						let expireDate = new AnandDate(stateMap.defaultExpireValue);
						openAddRecordForm.find("input[name='expireDatePart']").attr('value', expireDate.format('YYYY-MM-DD'));
						openAddRecordForm.find('input[name="expireDatePart"]').datepicker('update', expireDate.getDateObj());
						openAddRecordForm.find("input[name='expireTimePart']").val(expireDate.format('hh:mm:ss A'));
					}

					openAddRecordForm.find("input[name='name']").focus();
					refreshPhoneValidity(openAddRecordForm.find("input[name='phone']"));
					openAddRecordForm.find("input[name='phone']").change(function () {
						openAddRecordForm.find('.phone-detail .title').html('Mobile: ' + getInApp({ phone: $(this).val() }));
					});
					openAddRecordForm.submit(function () {
						setTimeout(function () {
							setAddFormValue(openAddRecordForm.find("input[name='name']"), '');
							recordAutocomplete?.resetForm(openAddRecordForm[0]);
							openAddRecordForm.find("input[name='people_count']").val('');
							openAddRecordForm.find("input[name='name']").focus();
						}, 500);
					});

					// $(".filtered-records").css("width", "48%");
					// $(".filtered-records").css("float", "right");
					$('#date_wise_count').css('display', 'block');
					$('#date_wise_count').css('overflow', 'auto');
					// openAddRecordForm.css('display', 'block');
					// Restores the saved show/hide choices instead of forcing the form open.
					props.props?.applyViewPrefs?.();

					configureRecordTypeAhead(openAddRecordForm);
					// configurePhoneTypeAhead(openAddRecordForm);
				}, 1000);

				// await timeout(10000);
				// let Model = ModelClass.Instance(stateMap.systemId);
				// var allRecords = Model.getRecords([], '', null) ?? [];

				// for (var i = 0; i < allRecords.length; i++) {
				// 	var record = allRecords[i];

				// 	if (record.card_no === undefined || parseInt(record.card_no) < 16) {
				// 		Model.deleteRecord(record, record[Records.IdFieldName], function () {
				// 			notification.showBottomNotification(
				// 				'Record deleted successfully: ' + record[Records.IdFieldName]
				// 			);
				// 		});
				// 		await timeout(100);
				// 	}
				// }
			}

			let Model = ModelClass.Instance(stateMap.systemId);
			Model.getUserPermissions('anumati_checkins', function (permissions) {
				stateMap.checkinAllowed = permissions.editAllowed;
			});

			Model.getUserPermissions('anumati_sms', function (permissions) {
				stateMap.smsAllowed = permissions.editAllowed;
			});

			Model.getUserPermissions('anumati_print', function (permissions) {
				stateMap.printAllowed = permissions.editAllowed;
			});

			if (Records.editAllowed === false) {
				$('.filtered-records').css('width', '100%');
			}

			var sortBtn = controlsHeader.find('.sort-records-btn');
			if (stateMap.printAllowed) {
				var printMenu = $(
					'<span class="dropdown hidden-sm hidden-xs">\n\
                    <a class="btn selection-btn dropdown-toggle" data-toggle="dropdown">\n\
						<span class="glyphicon glyphicon-print"></span>\n\
                        <span class="menu-text">Print</span>\n\
                        <span class="caret"></span>\n\
                    </a>\n\
                    <ul class="dropdown-menu">\n\
                        <li><a class="btn menu-text print-records">\n\
                                <span class="menu-text">Summary</span>\n\
                            </a>\n\
                        </li>\n\
                        <li>\n\
                            <a class="btn menu-text print-partial">\n\
                                <span class="menu-text">Card</span>\n\
                            </a>\n\
                        </li>\n\
                    </ul>\n\
                </span>'
				);

				sortBtn.before(printMenu);

				printMenu.find('.print-records').click(printSummary);
				// printMenu.find(".print-forms").click(printHtml);
				printMenu.find('.print-partial').click(printHtml);
			}

			if (Records.editAllowed) {
				controlsHeader
					.find('.select-dropdown')
					.find('ul')
					.append(
						$(`
				<li class="divider"></li>
				<li>
					<label><input type="checkbox" class="selection-show-approved" /> Approved</label>
				</li>
				<li>
					<label><input type="checkbox" class="selection-show-not-approved" /> Not Approved</label>
				</li>
				<li class="divider"></li>
				<li>
					<label><input type="checkbox" class="selection-show-printed" /> Printed</label>
				</li>
				<li>
					<label><input type="checkbox" class="selection-show-not-printed" /> Not Printed</label>
				</li>
				<li class="divider"></li>
				<li>
					<label><input type="checkbox" class="selection-show-ams" /> AMS SENT</label>
				</li>
				<li>
					<label><input type="checkbox" class="selection-show-not-ams" /> AMS NOT SENT</label>
				</li>				
				<li>
					<label><input type="checkbox" class="selection-show-delivered-ams" /> AMS DELIVERED</label>
				</li>
				<li>
					<label><input type="checkbox" class="selection-show-failed-ams" /> AMS FAILED</label>
				</li>
			`)
					);
			}

			controlsHeader.find('.selection-show-approved').click(() => {
				Records.refreshRecords();
			});

			controlsHeader.find('.selection-show-not-approved').click(() => {
				Records.refreshRecords();
			});

			controlsHeader.find('.selection-show-printed').click(() => {
				Records.refreshRecords();
				// Records.refreshRecords({ card_printed: true });
			});

			controlsHeader.find('.selection-show-not-printed').click(() => {
				Records.refreshRecords();
				// Records.refreshRecords(function (this: any) {
				// 	return this.card_printed == undefined ? true : false;
				// });
			});

			controlsHeader.find('.selection-show-ams').click(() => {
				Records.refreshRecords();
			});

			controlsHeader.find('.selection-show-not-ams').click(() => {
				Records.refreshRecords();
			});

			controlsHeader.find('.selection-show-delivered-ams').click(() => {
				Records.refreshRecords();
			});
			controlsHeader.find('.selection-show-not-delivered-ams').click(() => {
				Records.refreshRecords();
			});
			controlsHeader.find('.selection-show-failed-ams').click(() => {
				Records.refreshRecords();
			});
		};

		Records.hooks.configureHook = function () {
			let state: ApplicationState = store.getState();
			let records = state.dataState[stateMap.systemId]?.byId ?? {};

			let startingCardConfig = records[configMap.startingCardKey];
			stateMap.startingCardNo = startingCardConfig?.value ?? 0;

			let defaultPublishConfig = records[ssnDefaultPublishKey];
			stateMap.defaultPublishValue = defaultPublishConfig?.value;

			let defaultExpireConfig = records[ssnDefaultExpiryKey];
			stateMap.defaultExpireValue = defaultExpireConfig?.value;

			configureMainFilter();
		};

		Records.getAdditionalSearchFilters = function () {
			return getMainFilter();
		};

		Records.isSearchRangeTypeColumn = function (searchBy) {
			if (searchBy === 'card_no') {
				return true;
			}
			return false;
		};

		Records.updateRecordCount = async function () {
			// let Model = ModelClass.Instance(stateMap.systemId);
			// var allRecords = Model.getRecords([], '', null) ?? [];

			let defaultCounts = {
				cards: 0,
				members: 0,
				pendingMembers: 0,
				pendingCards: 0,
				checkins: 0,
				checkins_minor: 0,
				checkins_over: 0,
			};

			var datesCount = {};
			var total = { ...defaultCounts };

			let Model = ModelClass.Instance(stateMap.systemId);

			// While a date selection is active the table is built while ignoring that
			// selection, so every date column stays visible and can still be ticked.
			let selectedRecords =
				stateMap.dateFilter.length || stateMap.checkinDateFilter.length
					? Model.getRecords([getMainFilter(false)], '', null) ?? []
					: Records.getCurrentRecords();

			for (var i = 0; i < selectedRecords.length; i++) {
				var record = selectedRecords[i];

				if (new Date(record['permission_date']) < configMap.startDate) {
					continue;
				}

				if (record.card_no && record.card_no < stateMap.startingCardNo) {
					continue;
				}

				if (!record.card_no && record.approval && record.approval.status === 'Pending') {
					if (!datesCount[record['permission_date']]) {
						datesCount[record['permission_date']] = { ...defaultCounts };
					}
					datesCount[record['permission_date']]['pendingCards'] += 1;
					datesCount[record['permission_date']]['pendingMembers'] += parseInt(record['people_count'] ?? '0') || 0;

					total.pendingCards += 1;
					total.pendingMembers += parseInt(record['people_count'] ?? '0') || 0;
				} else if (record.card_no) {
					if (!datesCount[record['permission_date']]) {
						datesCount[record['permission_date']] = { ...defaultCounts };
					}
					datesCount[record['permission_date']]['cards'] += 1;
					datesCount[record['permission_date']]['members'] += parseInt(record['people_count'] ?? '0') || 0;

					total.cards += 1;
					total.members += parseInt(record['people_count'] ?? '0') || 0;
				}

				if (typeof record['checkin'] !== 'undefined') {
					var checkins: any[] = record['checkin'];
					checkins = checkins.sort((a, b) => a.created_at - b.created_at);
					var allowed_count = parseInt(record['people_count']) || 0;
					for (var j = 0; j < checkins.length; j++) {
						let checkinDate: string = checkins[j]['created_at'];
						checkinDate = checkinDate.split(' ')[0];
						if (!datesCount[checkinDate]) {
							datesCount[checkinDate] = { ...defaultCounts };
						}

						var checkin_count = parseInt(checkins[j]['checkin_count'] ?? '0') + parseInt(checkins[j]['checkin_count_ladies'] ?? '0');
						var minor_checkin_count = parseInt(checkins[j]['checkin_count_minor'] ?? '0') + parseInt(checkins[j]['checkin_count_infant'] ?? '0');
						allowed_count = allowed_count - checkin_count;

						if (checkins[j]['in_out'] === 'in') {
							datesCount[checkinDate]['checkins'] += checkin_count;
							total.checkins += checkin_count;

							datesCount[checkinDate]['checkins_minor'] += minor_checkin_count;
							total.checkins_minor += minor_checkin_count;

							if (allowed_count < 0) {
								datesCount[checkinDate]['checkins_over'] += -1 * allowed_count;
								total.checkins_over += -1 * allowed_count;
								allowed_count = 0;
							}
							// } else {
							// 	datesCount[checkinDate]['checkouts'] += count;
							// 	total.checkouts += count;
						}
					}
				}
			}

			var dateWiseCountTable = $('#date_wise_count');
			var headRow = dateWiseCountTable.find('#lables');
			var valuesRow = dateWiseCountTable.find('#values');
			var cardsRow = dateWiseCountTable.find('#cards');
			var checkinsRow = dateWiseCountTable.find('#checkins');
			var dates = Object.keys(datesCount).sort();

			headRow.html('');
			valuesRow.html('');
			cardsRow.html('');
			checkinsRow.html('');

			headRow.append($('<th></th>'));
			valuesRow.append($('<th>Members</th>'));
			cardsRow.append($('<th>Cards</th>'));
			checkinsRow.append($('<th>Checkins</th>'));
			for (var i = 0; i < dates.length; i++) {
				let date = dates[i];
				let dateChecked = stateMap.dateFilter.indexOf(date) >= 0 ? ' checked' : '';
				headRow.append(
					$(
						'<th><label class="count-filter"><input type="checkbox" class="date-filter-check" data-date="' +
							date +
							'"' +
							dateChecked +
							' />' +
							date +
							'</label></th>'
					)
				);
				let pendingMembersStr = '';
				let datesCountRow = datesCount[dates[i]];
				if (datesCountRow['pendingMembers'] > 0) {
					pendingMembersStr = "<span style='color: red'> / " + datesCountRow['pendingMembers'] + '</span>';
				}
				let pendingCardsStr = '';
				if (datesCountRow['pendingCards'] > 0) {
					pendingCardsStr = "<span style='color: red'> / " + datesCountRow['pendingCards'] + '</span>';
				}

				valuesRow.append($('<td>' + datesCountRow['members'] + pendingMembersStr + '</td>'));
				cardsRow.append($('<td>' + datesCountRow['cards'] + pendingCardsStr + '</td>'));

				let checkinCount = datesCountRow['checkins'] + datesCountRow['checkins_minor'];
				let overCount = datesCountRow['checkins_over'];

				let overStr = '';
				if (overCount > 0) {
					overStr = "<span style='color: red'> / " + overCount + '</span>';
				}

				let checkinChecked = stateMap.checkinDateFilter.indexOf(date) >= 0 ? ' checked' : '';
				checkinsRow.append(
					$(
						'<td><label class="count-filter"><input type="checkbox" class="checkin-filter-check" data-date="' +
							date +
							'"' +
							checkinChecked +
							' />' +
							checkinCount +
							' (' +
							datesCountRow['checkins'] +
							' & ' +
							datesCountRow['checkins_minor'] +
							')' +
							overStr +
							'</label></td>'
					)
				);
			}

			headRow.append($('<th>Total</th>'));
			let pendingMembersStr = '';
			if (total.pendingMembers > 0) {
				pendingMembersStr = "<span style='color: red'> / " + total.pendingMembers + '</span>';
			}
			let pendingCardsStr = '';
			if (total.pendingCards > 0) {
				pendingCardsStr = "<span style='color: red'> / " + total.pendingCards + '</span>';
			}

			valuesRow.append($('<td>' + total.members + pendingMembersStr + '</td>'));
			cardsRow.append($('<td>' + total.cards + pendingCardsStr + '</td>'));

			let overAllowedStr = '';
			if (total.checkins_over > 0) {
				overAllowedStr = "<span style='color: red'> / " + total.checkins_over + '</span>';
			}

			checkinsRow.append(
				$('<td>' + (total.checkins + total.checkins_minor) + ' (' + total.checkins + ' & ' + total.checkins_minor + ')' + overAllowedStr + '</td>')
			);
			if (total.checkins + total.checkins_minor === 0) {
				checkinsRow.css('display', 'none');
			} else {
				checkinsRow.css('display', 'table-row');
			}

			dateWiseCountTable.trigger('heightChange');

			return datesCount;
		};

		Records.selectionDropdownOptionsMap = { '*ssn': 'Shri Sant Nagar' };
		// stateMap.selectionDropdown = $('#selection-dropdown select');
		// stateMap.selectionDropdown.find('option').remove();
		// stateMap.selectionDropdown.append($("<option value='ssn' selected='selected'>Shri Sant Nagar</option>"));

		Records.detailTileSelector = '#anumati-detail-record';
		Records.briefTileSelector = '#anumati-detail-record';
		Records.addTileSelector = '#anumati-add-record';
		Records.detailFormSelector = '#anumati-detail-record-form';
		Records.imageUploadSelector = null;

		Records.populateBriefTile = populateBriefTile;
		Records.populateDetailTile = populateDetailTile;
		Records.populateDetailForm = populateDetailForm;

		let MjBjModel = ModelClass.Instance('mjbj');
		stateMap.mjbjModel = MjBjModel;
		stateMap.mjbjModel.initModule({
			systemId: 'mjbj',
			forceUpdate: configMap['forceUpdate'],
			prepareRecord: prepareRecord,
		});
		stateMap.mjbjModel.getRecords([], '');
		// anand.mjbjModel.getRecords([], '', function () {
		Records.initModule({
			systemId: 'anumati',
			forceUpdate: configMap['forceUpdate'],
			prepareRecord: prepareRecord,
			orderRecords: orderPinnedFirst,
			props: props,
			addTileFormValidationRules: {
				name: {
					required: true,
				},
				people_count: {
					required: true,
				},
				permission_date: {
					required: true,
					date: true,
				},
				reference: {
					required: true,
				},
				phone: {
					required: true,
					mobileNumber: true,
				},
				'checkin_name[]': {
					required: function (el) {
						var parent = $(el).parents('.multi-field-row');
						if (
							(parent.find('input[name="checkin_count[]"]').val() as any)?.length ||
							(parent.find('input[name="checkin_count_ladies[]"]').val() as any)?.length ||
							(parent.find('input[name="checkin_phone[]"]').val() as any)?.length
						) {
							return true;
						}

						return false;
					},
				},
				'checkin_count[]': {
					required: function (el) {
						var parent = $(el).parents('.multi-field-row');
						if (
							(parent.find('input[name="checkin_count_ladies[]"]').val() as any)?.length <= 0 &&
							((parent.find('input[name="checkin_name[]"]').val() as any)?.length ||
								(parent.find('input[name="checkin_phone[]"]').val() as any)?.length)
						) {
							return true;
						}

						return false;
					},
				},
				'checkin_count_ladies[]': {
					required: function (el) {
						var parent = $(el).parents('.multi-field-row');
						if (
							(parent.find('input[name="checkin_count[]"]').val() as any)?.length <= 0 &&
							((parent.find('input[name="checkin_name[]"]').val() as any)?.length ||
								(parent.find('input[name="checkin_phone[]"]').val() as any)?.length)
						) {
							return true;
						}

						return false;
					},
				},
				'checkin_phone_ignore[]': {
					required: function (el) {
						var parent = $(el).parents('.multi-field-row');
						if (
							(parent.find('input[name="checkin_count[]"]').val() as any)?.length ||
							(parent.find('input[name="checkin_name[]"]').val() as any)?.length
						) {
							return true;
						}

						return false;
					},
				},
			},
		});
		// });
	}

	/** Pinned records are floated to the top, keeping the existing order within each group. */
	function orderPinnedFirst(records: any[]) {
		let pinnedTiles = stateMap.pinnedTiles ?? {};

		if (!records?.length || !Object.keys(pinnedTiles).length) {
			return records;
		}

		let pinned = records.filter((record) => pinnedTiles[record?.id]);

		if (!pinned.length || pinned.length === records.length) {
			return records;
		}

		return pinned.concat(records.filter((record) => !pinnedTiles[record?.id]));
	}

	/** Describes the filters that decide which records a bulk edit would touch. */
	function describeActiveFilters(): string[] {
		let filters: string[] = [];

		let placeDropdown = $("select[name='main_filter_dropdown']");
		let place = placeDropdown.find('option:selected').text()?.trim();
		if (placeDropdown.is(':visible') && place) {
			filters.push(`Place: ${place}`);
		}

		// Anumati hides this dropdown and gives it a single option that repeats the place,
		// so it is only worth showing where the user can actually see and change it.
		let selectionDropdown = $('#selection-dropdown');
		let selection = selectionDropdown.find('select option:selected').text()?.trim();
		if (selectionDropdown.is(':visible') && selection) {
			filters.push(`Showing: ${selection}`);
		}

		let search = ($('#search-text-input input').val() as string)?.trim();
		if (search) {
			filters.push(`Search: "${search}"`);
		}

		if (stateMap.refFilter?.length) {
			filters.push(`Ref: ${stateMap.refFilter.join(', ')}`);
		}

		if (stateMap.dateFilter?.length) {
			filters.push(`Dates: ${stateMap.dateFilter.join(', ')}`);
		}

		if (stateMap.checkinDateFilter?.length) {
			filters.push(`Check-in dates: ${stateMap.checkinDateFilter.join(', ')}`);
		}

		let toggles: [string, string][] = [
			['.selection-show-approved', 'Approved'],
			['.selection-show-not-approved', 'Not approved'],
			['.selection-show-printed', 'Printed'],
			['.selection-show-not-printed', 'Not printed'],
			['.selection-show-ams', 'AMS sent'],
			['.selection-show-not-ams', 'AMS not sent'],
			['.selection-show-delivered-ams', 'AMS delivered'],
			['.selection-show-failed-ams', 'AMS failed'],
		];

		let active = toggles.filter(([selector]) => $(selector).is(':checked')).map(([, label]) => label);

		if (active.length) {
			filters.push(`Flags: ${active.join(', ')}`);
		}

		return filters;
	}

	function configureMainFilter() {
		$("select[name='main_filter_dropdown']").on('change', function () {
			Records.refreshRecords();
		});
	}

	function getMainFilter(applyDateSelection = true) {
		var mainFilter = $("select[name='main_filter_dropdown']");
		var mainFilterVal = mainFilter.val();

		let showApproved = $('.selection-show-approved').is(':checked');
		let showNotApproved = $('.selection-show-not-approved').is(':checked');

		let showPrinted = $('.selection-show-printed').is(':checked');
		let showNotPrinted = $('.selection-show-not-printed').is(':checked');

		let showAMS = $('.selection-show-ams').is(':checked');
		let showNotAMS = $('.selection-show-not-ams').is(':checked');
		let showDeliveredAMS = $('.selection-show-delivered-ams').is(':checked');
		let showFailedAMS = $('.selection-show-failed-ams').is(':checked');

		let filters = function (this: any) {
			let result =
				this.place === mainFilterVal &&
				(!this.card_no || this.card_no >= stateMap.startingCardNo) &&
				new Date(this.permission_date) >= configMap.startDate;

			if (stateMap.checkinAllowed === true && Records.editAllowed === false) {
				result = result && this.card_no;
			}

			if (showApproved !== showNotApproved) {
				let orResult = false;

				if (showApproved) {
					orResult = orResult || !this.approval || this.approval?.status === 'Approved';
				}

				if (showNotApproved) {
					orResult = orResult || (this.approval && this.approval.status !== 'Approved');
				}

				result = result && orResult;
			}

			// if (showApproved) {
			// 	result = result && (!this.approval || this.approval?.status === 'Approved');
			// }

			// if (showNotApproved) {
			// 	result = result && this.approval && this.approval.status !== 'Approved';
			// }

			if (showNotPrinted !== showPrinted) {
				let orResult = false;

				if (showPrinted) {
					orResult = orResult || this.card_printed;
				}

				if (showNotPrinted) {
					orResult = orResult || !this.card_printed;
				}

				result = result && orResult;
			}

			if (showAMS) {
				result = result && this.ams?.state === 'AMS_SENT';
			}

			if (showNotAMS) {
				result = result && !this.ams;
			}

			if (showDeliveredAMS) {
				result = result && this.ams?.state === 'AMS_DELIVERED';
			}

			if (showFailedAMS) {
				result = result && this.ams && this.ams.state !== 'AMS_SENT' && this.ams.state !== 'AMS_DELIVERED';
			}

			if (stateMap.refFilter.length) {
				result = result && stateMap.refFilter.indexOf(this.reference) >= 0;
			}

			// Date and check-in selections from the date wise count table combine as an OR,
			// so ticking several boxes widens the result rather than narrowing it.
			if (applyDateSelection && (stateMap.dateFilter.length || stateMap.checkinDateFilter.length)) {
				let matchesSelection = stateMap.dateFilter.indexOf(this.permission_date) >= 0;

				if (!matchesSelection && stateMap.checkinDateFilter.length && Array.isArray(this.checkin)) {
					matchesSelection = this.checkin.some(
						(checkin) =>
							checkin?.in_out === 'in' && stateMap.checkinDateFilter.indexOf(String(checkin?.created_at ?? '').split(' ')[0]) >= 0
					);
				}

				result = result && matchesSelection;
			}

			return result;
		};

		return filters;
	}

	function prepareRecord(record, isAdd, isAdmin = false) {
		if (record['permission_date']) {
			record['permission_date'] = Utils.formatDate(record['permission_date']);
		}

		if (record['publishDateTime']) {
			let publishDate = parseDateTime(record['publishDateTime']);

			if (!publishDate) {
				throw new Error('Invalid publish date/time.');
			}

			record['publishTime'] = firebase.firestore.Timestamp.fromDate(publishDate);
		} else if (isAdd && stateMap.defaultPublishValue) {
			record['publishTime'] = firebase.firestore.Timestamp.fromMillis(stateMap.defaultPublishValue.seconds * 1000);
		}

		if (record['expireDateTime']) {
			let expireDate = parseDateTime(record['expireDateTime']);

			if (!expireDate) {
				throw new Error('Invalid expiry date/time.');
			}

			record['expireTime'] = firebase.firestore.Timestamp.fromDate(expireDate);
		} else if (isAdd && stateMap.defaultExpireValue) {
			record['expireTime'] = firebase.firestore.Timestamp.fromMillis(stateMap.defaultExpireValue.seconds * 1000);
		}

		record['place'] = $("select[name='main_filter_dropdown']").val();

		if (record['people_count']) {
			record['people_count'] = parseInt(record['people_count']);
		}

		if (record['name']) {
			record['name'] = capitalizeName(record['name']);
		}

		if (record['phone']) {
			let phone = record['phone'].trim();
			record['phone'] = normalizeMobileNumber(phone) ?? (phone.startsWith('+') ? phone : '+91' + phone);
		}

		let checkins: string[] = record['checkin_ids'] ?? [];
		if (checkins.length > 1) {
			let names = record['checkin_name'];
			let phones = record['checkin_phone'];
			let inOuts = record['in_out'];
			let counts = record['checkin_count'];
			let ladies_counts = record['checkin_count_ladies'];
			let minor_counts = record['checkin_count_minor'];
			let infant_counts = record['checkin_count_infant'];
			let created = record['created_at'];
			let cities = record['checkin_city'];
			let conveyance = record['checkin_conveyance'];

			record.checkin = record.checkin || [];

			checkins.forEach((id, index) => {
				if (index === 0) return;

				if (!counts[index] && !ladies_counts[index]) {
					return;
				}

				let checkinId = id && id.length ? id : uuidv1();

				// if (created[index]) {
				// 	let createdAt = new AnandDate(created[index]);
				// 	if (createdAt.getDateObj() > new Date()) {
				// 		createdAt.subtract(13.5, 'hour');
				// 		created[index] = createdAt.format('YYYY-MM-DD HH:mm:ss');
				// 	}
				// }

				let checkinRecord = {
					id: checkinId,
					checkin_name: Utils.upperFirstAll(names[index]),
					checkin_count: parseInt(counts[index]) || 0,
					checkin_count_ladies: parseInt(ladies_counts[index]) || 0,
					checkin_count_minor: parseInt(minor_counts[index]) || 0,
					checkin_count_infant: parseInt(infant_counts[index]) || 0,
					checkin_phone: phones[index],
					checkin_city: cities[index],
					checkin_conveyance: conveyance[index],
					in_out: inOuts[index],
					parent_id: record.id,
					status: 'active',
					created_at: created[index] || new AnandDate().format('YYYY-MM-DD HH:mm:ss'),
				};

				let checkinIndex = -1;
				if (id && id.length) {
					let checkinRecordIndex = (record.checkin as any[]).findIndex((value) => value.id == id);
					if (checkinRecordIndex > -1) {
						checkinIndex = checkinRecordIndex;
					}
				}

				if (checkinIndex > -1) {
					record.checkin[checkinIndex] = checkinRecord;
				} else {
					record.checkin.push(checkinRecord);
				}
			});
		}

		delete record['checkin_ids'];
		delete record['checkin_name'];
		delete record['checkin_phone'];
		delete record['checkin_phone_ignore'];
		delete record['in_out'];
		delete record['checkin_count'];
		delete record['checkin_count_ladies'];
		delete record['checkin_count_minor'];
		delete record['checkin_count_infant'];
		delete record['checkin_city'];
		delete record['checkin_conveyance'];
		delete record['created_at'];

		delete record['phone_ignore'];
		delete record['image'];

		delete record['publishDateTime'];
		delete record['expireDateTime'];

		if (isAdd) {
			record['card_printed'] = false;
			record['ams'] = false;

			if (!isAdmin) {
				record['approval'] = {
					status: 'Pending',
				};
			}
		}

		if (stateMap.checkinAllowed === true && Records.editAllowed === false) {
			delete record['name'];
			delete record['people_count'];
			delete record['reference'];
			delete record['phone'];
			delete record['permission_date'];
		}

		console.log(JSON.stringify(record));
		return record;
	}

	function getAnySearchFilter(query) {
		let result: any[] = [
			{ card_no: { '==': query } },
			{ name: { likenocase: query } },
			{ permission_date: { likenocase: query } },
			{ reference: { likenocase: query } },
			{ byName: { likenocase: query } },
		];

		if (Records.editAllowed) {
			result.push({ phone: { likenocase: query } });
		}

		return result;
	}

	function configureRecordTypeAhead(tile) {
		if (tile[0]) recordAutocomplete?.bindForm(tile[0]);
	}

	function configurePhoneTypeAhead(tile) {
		var substringMatcher = function () {
			return function findMatches(query, callback) {
				query = $.trim(query);

				let Model = ModelClass.Instance(stateMap.systemId);
				let records = Model.getRecords([{ phone: { leftnocase: query } }], 'phone logical', null);
				let map: any = {};
				let uniqueRecords = records.filter((item) => (map[item.phone] ? false : (map[item.phone] = true)));

				callback(uniqueRecords);
			};
		};

		tile.find("input[name='phone']").typeahead(
			{
				hint: false,
				minLength: 3,
				highlight: true,
				classNames: {
					menu: 'tt-dropdown-menu',
				},
			},
			{
				name: 'phone',
				display: 'phone',
				source: substringMatcher(),
			}
		);
	}

	async function populateBriefTile(sampleTile, record) {
		return await populateDetailTile(sampleTile, record);
	}

	async function sendSMS(record, callback?) {
		if (!record.phone || $.trim(record.phone) === '') {
			callback && callback('Error: Phone number not valid!');
			return;
		}

		if (!record.card_no) {
			callback && callback('Error: Card number not populated!');
			return;
		}

		let cardNo = record.card_no;
		let name = record.name;
		let count = record.people_count;
		let date = new AnandDate(record.permission_date).format('DD/MM/YYYY');
		let message: string = `Shri Anandpur Trust - SSN Card ID: ${cardNo}\n${name}\n# ${count}\n${date}\nAccommodation in SHRI SANT NAGAR is only for one night.`;

		var sendSMS = firebase.app().functions('asia-east2').httpsCallable('sendSMS');
		let result = await sendSMS({
			messages: [
				{
					recordId: record.id,
					phone: record.phone,
					text: message,
				},
			],
			// cc: '+918169023750',
			DLT_TE_ID: '1307161374008328563',
			collection: 'anumati',
		});

		if (callback) callback('AMS Request Sent');

		// SendSMS.send(
		// 	[`+91${record.phone}`, '+918169023750'],
		// 	{
		// 		id: record.id,
		// 		name: record.name,
		// 		count: record.people_count,
		// 		date: new AnandDate(record.permission_date).format('DD/MM/YYYY'),
		// 	},
		// 	function (response) {
		// 		//Returns Message ID, If Sent Successfully or the appropriate Error Message
		// 		console.log(response);
		// 		callback && callback('SMS Request Sent');
		// 		// record.sms_sent = true;

		// 		// let Model = ModelClass.Instance(stateMap.systemId);
		// 		// Model.editRecord({ sms_sent: true }, record.id, () => {
		// 		// 	callback && callback('SMS Request Sent');
		// 		// });
		// 	}
		// );
	}

	async function sendAMS(record) {
		if (!record.phone || $.trim(record.phone) === '') {
			throw 'Error: Phone number not valid!';
		}

		if (!record.card_no) {
			throw 'Error: Card number not populated!';
		}

		let fbFuncs = firebase.app().functions('asia-east2');
		// var refreshInApp = fbFuncs.httpsCallable('refreshInApp');
		// let limit = 500;
		// let startAt = undefined;
		// let size = 0;

		// do {
		// 	let result = await refreshInApp({
		// 		limit,
		// 		startAt
		// 	});
		// 	console.log(result);
		// 	startAt = result.data.lastRecord.name;
		// 	size = result.data.size;
		// } while (size >= limit);

		var sendAMSAPI = fbFuncs.httpsCallable('sendAMS');
		await sendAMSAPI({
			messages: [
				{
					recordId: record.id,
				},
			],
			collection: 'anumati',
		});

		return 'AMS Request Sent';
	}

	/**
	 * Sharing is an editor action, so the button stays hidden for read only and check-in
	 * only users. A card also only makes sense to share once it has been issued, so it is
	 * hidden until the record has a card number. Cards already shared from this device
	 * keep a tick inside the button.
	 */
	function configureShareButton(sampleTile, record) {
		let shareButton = sampleTile.find('.record-share-button');

		if (!shareButton.length) {
			return;
		}

		if (!Records.editAllowed || !record['card_no']) {
			shareButton.hide();
			return;
		}

		let applyShared = (shared: boolean) => {
			shareButton.toggleClass('shared', shared);
			shareButton.html(shared ? 'Shared<span class="glyphicon glyphicon-ok"></span>' : 'Share');
		};

		applyShared(isCardShared(record['id']));

		shareButton.off('click.tileShare').on('click.tileShare', async function (e) {
			// The tile itself opens the details dialog on click.
			e.preventDefault();
			e.stopPropagation();

			if (shareButton.prop('disabled')) {
				return;
			}

			shareButton.prop('disabled', true);

			try {
				let result = await shareAnumatiCard(record);

				if (result === 'shared' || result === 'copied') {
					markCardShared(record['id']);
					applyShared(true);
				}

				if (result === 'copied') {
					notification.showBottomNotification('Card image copied. Paste it into the chat');
				} else if (result === 'unsupported') {
					notification.showBottomNotification('Sharing is not supported on this browser');
				}
			} catch (error) {
				notification.showBottomNotification(error?.message ?? 'Could not share the card');
			} finally {
				shareButton.prop('disabled', false);
			}
		});
	}

	async function populateDetailTile(sampleTile, recordOrig) {
		var record = {};
		for (var key in recordOrig) {
			if (key !== 'deleted' && (recordOrig[key] == null || recordOrig[key] == '') && recordOrig[key] !== 0) {
				record[key] = '&nbsp';
			} else {
				record[key] = recordOrig[key];
			}
		}

		sampleTile.find('.self-detail.value').html(record['name']);

		let opsState = '';

		if (Records.editAllowed) {
			let printState = recordOrig['card_printed'] ? ' [Card Printed]' : '';
			let smsState = recordOrig['sms']
				? ` [${recordOrig.sms.state} (${recordOrig.sms.reportAt ? new AnandDate(recordOrig.sms.reportAt).format('DD-MM HH:mm') : ''})]`
				: '';
			let amsState = recordOrig['ams']
				? ` [${recordOrig.ams.state}${
						recordOrig.ams.error
							? ' (' + recordOrig.ams.error + ')'
							: recordOrig.ams.sentAt
							? ' (' + new AnandDate(recordOrig.ams.sentAt).format('DD-MM HH:mm') + ')'
							: ''
				  }]`
				: '';
			opsState = printState + smsState + amsState;
		}

		let cardNo = record['card_no'];
		if (record['approval'] && (!cardNo || record['approval'].status !== 'Approved')) {
			let approval = record['approval'];
			let status = approval['status'];
			let colorMap = { Pending: 'blueviolet', Rejected: 'red', Approved: 'green', Blocked: 'chocolate' };
			cardNo = `${cardNo ?? ''} <span style="color:${colorMap[status]};font-weight:bold">[Approval ${status}]</span>`;
		}
		sampleTile.find('.card-detail.value').html((cardNo ?? '') + opsState);

		sampleTile.find('.ref-detail.value').html(record['reference']);

		if (Records.editAllowed) {
			sampleTile.find('.phone-detail.value').html(record['phone'] + getInApp(record));
		} else {
			sampleTile.find('.phone-detail').prev().hide();
			sampleTile.find('.phone-detail').hide();

			sampleTile.find('.publish').hide();
			sampleTile.find('.expiry').hide();

			sampleTile.find('.created-by-detail').prev().hide();
			sampleTile.find('.created-by-detail').hide();
		}

		sampleTile.find('.created-by-detail.value').html(record['byName'] ?? 'Unknown');
		let expireTime = new AnandDate(record['expireTime']);
		let expireStr = expireTime.format('dd, Do MMM YYYY hh:mm:ss A');

		if (expireTime.isSameOrBefore(new AnandDate())) {
			sampleTile.find('.expiry').css('color', 'red');
			expireStr += ' [Expired]';
		}
		sampleTile.find('.expire-time-detail.value').html(expireStr);

		let publishTime = new AnandDate(record['publishTime']);
		let publishStr = publishTime.format('dd, Do MMM YYYY hh:mm:ss A');
		if (publishTime.isAfter(new AnandDate())) {
			sampleTile.find('.publish').css('color', 'blueviolet');
			publishStr += ' [Not Published]';
		}
		sampleTile.find('.publish-time-detail.value').html(publishStr);

		if (record['permission_date'] !== null) {
			var dateAr = record['permission_date'].split('-');
			if (dateAr.length === 3) {
				var dateStr = dateAr[2] + '-' + dateAr[1] + '-' + dateAr[0];
				dateStr = Utils.getDateStr(dateAr[0], dateAr[1], dateAr[2]);
				sampleTile.find('.date-detail.value').html(dateStr);
			} else {
				sampleTile.find('.date-detail.value').html(record['permission_date']);
			}
		}

		if (record['deleted']) {
			sampleTile.find('.deleted').show();
			sampleTile.find('.deleted-detail.value').html('True');
		} else {
			sampleTile.find('.deleted').hide();
		}

		let totalCheckins = 0;
		if (typeof recordOrig['checkin'] !== 'undefined' && recordOrig['checkin'] !== null && recordOrig['checkin'].length > 0) {
			var checkins = recordOrig['checkin'];
			for (var i = 0; i < checkins.length; i++) {
				var checkinRow = sampleTile.find('.check-in-details #check-in-data-detail').clone();
				checkinRow.attr('id', 'check-in-detail' + '-' + i);
				// checkinRow.find('.inout').html(checkins[i]['in_out'] === 'in' ? 'Check-In' : 'Check-Out');
				checkinRow.find('.name').html(checkins[i]['checkin_name']);

				let majorCount = (checkins[i]['checkin_count'] ?? 0) + (checkins[i]['checkin_count_ladies'] ?? 0);
				let minorCount = (checkins[i]['checkin_count_minor'] ?? 0) + (checkins[i]['checkin_count_infant'] ?? 0);

				checkinRow.find('.count').html(majorCount + ' & ' + minorCount);
				checkinRow.find('.phone').html(checkins[i]['checkin_phone']);
				//				checkinRow.find('.date').html(checkins[i]['created_at']);

				checkinRow.find('.date input').datepicker({
					format: 'D, dd M yyyy',
					autoclose: true,
					todayHighlight: true,
					todayBtn: 'linked',
				});
				updateDateTime(checkins[i]['created_at'], checkinRow.find('.date input'));
				checkinRow.removeClass('hidden');
				sampleTile.find('.main-details .check-in-detail').append(checkinRow);

				totalCheckins += majorCount;
			}
		} else {
			sampleTile.find('.check-in-details').hide();
		}

		if (stateMap.checkinAllowed === true && Records.editAllowed === false) {
			sampleTile.find('.check-in-details').show();
			sampleTile.find('.checkins-btn').show();
			sampleTile.find('.checkins-btn').on('click', function (e) {
				e.stopPropagation();
				handleCheckins(sampleTile);
			});
		}

		let remainingCount = record['people_count'] - totalCheckins;
		sampleTile
			.find('.count-detail.value')
			.html(record['people_count'] + "<span style='color: " + (remainingCount >= 0 ? 'green' : 'red') + "'> [Remaining: " + remainingCount + ']</span>');

		if (stateMap.printAllowed === false) {
			sampleTile.find('.record-print-button').hide();
		} else {
			sampleTile.find('.record-print-button').show();
			sampleTile.find('.record-print-button').on('click', function (e: MouseEvent) {
				e.stopPropagation();
				printHtml(e, [recordOrig]);
			});
		}

		if (stateMap.smsAllowed === false) {
			sampleTile.find('.record-sms-button').hide();
			sampleTile.find('.record-ams-button').hide();
		}

		if (Records.editAllowed) {
			sampleTile.find('.record-copy-button').on('click', function (e: MouseEvent) {
				e.stopPropagation();
				copyRecordToAddForm(recordOrig);
			});
		} else {
			sampleTile.find('.record-copy-button').hide();
		}

		configureShareButton(sampleTile, recordOrig);

		if (true) {
			let status = record['approval'] ? record['approval']['status'] : 'Approved';
			if (!record['card_no']) {
				sampleTile.find('.record-approve-button').html(status === 'Rejected' ? 'Approve' : 'Approve/Reject');
			} else {
				sampleTile.find('.record-approve-button').html(status === 'Approved' ? 'Block' : 'Unblock');
			}

			sampleTile.find('.record-approve-button').on('click', function (e: MouseEvent) {
				e.stopPropagation();

				let buttons = [];
				if (!record['card_no'] && status !== 'Approved') {
					buttons.push({
						label: 'Yes, Approve!',
						cssClass: 'btn-success',
						status: 'Approved',
					});
				}
				if (!record['card_no'] && status !== 'Rejected') {
					buttons.push({
						label: 'Reject!',
						cssClass: 'btn-danger',
						status: 'Rejected',
					});
				}
				if (record['card_no'] && status !== 'Blocked') {
					buttons.push({
						label: 'Block!',
						cssClass: 'btn-warning',
						status: 'Blocked',
					});
				}
				if (record['card_no'] && status === 'Blocked') {
					buttons.push({
						label: 'Unblock!',
						cssClass: 'btn-warning',
						status: 'Approved',
					});
				}

				BootstrapDialog.show({
					type: BootstrapDialog.TYPE_PRIMARY,
					title: 'Moderate the Card',
					message: 'Take action on this card request of: ' + record['name'],
					buttons: buttons
						.map((button) => {
							return {
								label: button.label,
								cssClass: button.cssClass,
								action: function (dialog) {
									let update: any = {
										approval: {
											status: button.status,
										},
									};

									// Cards submitted from outside the system may carry an
									// uncapitalised name, so correct it as part of moderation.
									let correctedName = capitalizeName(recordOrig['name']);
									if (correctedName && correctedName !== recordOrig['name']) {
										update.name = correctedName;
									}

									let Model = ModelClass.Instance(stateMap.systemId);
									Model.editRecord(update, record[Records.IdFieldName], function () {
										dialog.close();
									});
								},
							};
						})
						.concat([
							{
								label: 'Cancel',
								cssClass: 'btn-primary',
								action: function (dialog) {
									dialog.close();
								},
							},
						]),
				});
			});
		} else {
			sampleTile.find('.record-approve-button').hide();
		}

		sampleTile.find('.record-sms-button').on('click', function (e: MouseEvent) {
			e.stopPropagation();
			sendSMS(recordOrig, (response) => {
				notification.showBottomNotification(response);
			});
			// msg91.sendOne(
			// 	'171655AWw8xnhTQx4N5b927a6a',
			// 	`+91${recordOrig.phone}`,
			// 	`Shri Anandpur Trust - SSN Card ID: ${recordOrig.id}\n${recordOrig.name}\n# ${
			// 		recordOrig.people_count
			// 	}\n${new AnandDate(recordOrig.permission_date).format('DD/MM/YYYY')}`,
			// 	'SATmsg',
			// 	'4',
			// 	'91',
			// 	function (response) {
			// 		//Returns Message ID, If Sent Successfully or the appropriate Error Message
			// 		console.log(response);
			// 	}
			// );
		});

		sampleTile.find('.record-ams-button').on('click', async function (e: MouseEvent) {
			e.stopPropagation();
			try {
				let response = await sendAMS(recordOrig);
				notification.showBottomNotification(response);
			} catch (error) {
				notification.showBottomNotification(error);
			}
		});

		if (Records.editAllowed === false) {
			sampleTile.expansionAllowed = false;
		}

		return sampleTile;
	}

	function getInAppRecord(record) {
		if (!record['phone'] || record['phone'] === '') {
			return '';
		}

		let phone = record['phone'].startsWith('+') ? record['phone'] : '+91' + record['phone'];
		var records: any[] = stateMap.mjbjModel.getRecords([{ inApp: { has: phone }, deleted: false }], 'name logical', null);

		return records.length ? records[0] : undefined;
	}

	function getInApp(record) {
		let inAppRecord = getInAppRecord(record);

		let refName = '';
		if (inAppRecord) {
			var titleMapping = {
				Mahatma: 'Mh.',
				Bai: 'Bai',
				Bhagat: 'Bh.',
				Dada: 'Dada',
				Dadi: 'Dadi',
			};
			refName = (titleMapping[inAppRecord['title']] ?? inAppRecord['title']) + ' ' + inAppRecord['name'] + ' Ji';
		}

		return inAppRecord ? ` <span style="color:green">[InApp: ${refName}]</span>` : ' <span style="color:red">[NotInApp]</span>';
	}

	/**
	 * Blocks submission until the mobile number is usable. The number is mandatory, so an
	 * empty field also blocks, but it is not marked red until something invalid is typed.
	 */
	function refreshPhoneValidity(phoneInput) {
		let form = phoneInput.closest('form');

		if (!form.length) {
			return;
		}

		let value = $.trim(phoneInput.val() as string);
		let invalid = !!value && !isValidMobileNumber(value);

		phoneInput.toggleClass('invalid-phone', invalid);
		form.find('button[type="submit"]').prop('disabled', invalid || !value);
	}

	/**
	 * typeahead keeps its own copy of the query and resets the input back to it on focus,
	 * so a plain .val() on a typeahead-enabled field gets wiped.
	 */
	function setAddFormValue(input, value) {
		input.trigger('record-suggestions:reset');
		if (input.hasClass('tt-input') && typeof input.typeahead === 'function') {
			input.typeahead('val', value);
		} else {
			input.val(value);
		}
	}

	/**
	 * Pre-fills the inline add form with the details of an existing record so a similar
	 * entry can be created without retyping. Only the user-entered fields are copied;
	 * card no, approval and check-in data belong to the original record.
	 */
	function copyRecordToAddForm(record) {
		let addForm: any = $('#anumati-add-record-open');

		if (!addForm.length) {
			return;
		}

		if (!addForm.is(':visible')) {
			stateMap.toggleForm?.();
		}

		setAddFormValue(addForm.find('input[name="name"]'), record['name'] ?? '');
		setAddFormValue(addForm.find('input[name="reference"]'), record['reference'] ?? '');

		addForm.find('input[name="people_count"]').val(record['people_count'] ?? '');

		// Triggers the registered change handler so the "Mobile:" label stays in sync.
		addForm
			.find('input[name="phone"]')
			.val(record['phone'] ?? '')
			.change();

		let permissionDate = record['permission_date'];
		if (permissionDate) {
			let dateAr = permissionDate.toString().split('-');
			if (dateAr.length === 3) {
				let date = new Date(parseInt(dateAr[0]), parseInt(dateAr[1]) - 1, parseInt(dateAr[2]));
				addForm.find('input[name="permission_date"]').attr('value', permissionDate);
				addForm.find('input[name="permission_date"]').datepicker('update', date);
			}
		}

		addForm.get(0)?.scrollIntoView({ behavior: 'smooth', block: 'center' });

		let nameInput: any = addForm.find('input[name="name"]');
		nameInput.focus();

		// Focusing a typeahead field opens its suggestion menu over the form.
		if (nameInput.hasClass('tt-input') && typeof nameInput.typeahead === 'function') {
			nameInput.typeahead('close');
		}

		notification.showBottomNotification('Details copied to the add form');
	}

	/**
	 * Mounts the Material date and time pickers into the cloned record form. Any previously
	 * mounted fields are unmounted first so React trees are not left behind when the edit
	 * dialog is reopened.
	 */
	function mountDateTimeFields(sampleTile, record) {
		(stateMap.dateTimeFieldUnmounts ?? []).forEach((unmount) => unmount());
		stateMap.dateTimeFieldUnmounts = [];

		let fields = [
			{ field: 'publishDateTime', label: 'Publish Time', value: record['publishTime'] },
			{ field: 'expireDateTime', label: 'Expire Time', value: record['expireTime'] },
		];

		fields.forEach(({ field, label, value }) => {
			let container = sampleTile.find('.datetime-field[data-field="' + field + '"]').get(0);

			if (!container) {
				return;
			}

			stateMap.dateTimeFieldUnmounts.push(
				mountDateTimeField(container, {
					name: field,
					label: label,
					initialValue: value ? new AnandDate(value).getDateObj() : null,
				})
			);
		});
	}

	function populateDetailForm(sampleTile, record) {
		sampleTile.find('.card-detail .value').html(record['card_no'] ?? '');
		sampleTile.find('input[name="name"]').val(record['name']);
		sampleTile.find('input[name="people_count"]').val(record['people_count']);
		sampleTile.find('input[name="reference"]').val(record['reference']);

		if (record['phone']) {
			sampleTile.find('input[name="phone_ignore"]').intlTelInput('setNumber', record['phone']);
			sampleTile.find('input[name="phone"]').val(record['phone']);
			sampleTile.find('.phone-detail .title').html('Mobile: ' + getInApp(record));
		}

		var dateAr = record['permission_date'].split('-');
		var date = new Date(parseInt(dateAr[0]), parseInt(dateAr[1]) - 1, parseInt(dateAr[2]));
		sampleTile.find('input[name="permission_date"]').attr('value', record['permission_date']);
		sampleTile.find('input[name="permission_date"]').datepicker('update', date);

		mountDateTimeFields(sampleTile, record);

		if (Records.editAllowed === false) {
			sampleTile.find('input[name="name"]').attr('disabled', 'disabled');
			sampleTile.find('input[name="people_count"]').attr('disabled', 'disabled');
			sampleTile.find('input[name="reference"]').attr('disabled', 'disabled');
			sampleTile.find('input[name="permission_date"]').attr('disabled', 'disabled');

			sampleTile.find('.phone-detail').hide();
			sampleTile.find('.publish-detail').hide();
			sampleTile.find('.expire-detail').hide();
		}

		if (typeof record['checkin'] !== 'undefined' && record['checkin'].length > 0) {
			var checkins = record['checkin'];
			let checkinParentDiv = sampleTile.find('.main-details .check-in-detail');
			var multiFieldAddBtn = checkinParentDiv.find('.hidden .multi_field_add_btn');
			var checkinDivId = multiFieldAddBtn.attr('data-field-id');

			// var checkinDivId = Records.populateMultiAddFields(sampleTile.find('.main-details .check-in-detail'), checkins.length);
			for (var i = 0; i < checkins.length; i++) {
				var checkinDiv = sampleTile.find('#' + checkinDivId + (i + 1));
				checkinDiv.find('input[name="checkin_ids[]"]').val(checkins[i]['id']);
				checkinDiv.find('input[name="created_at[]"]').val(checkins[i]['created_at']);

				checkinDiv.find('input[name="checkin_name[]"]').val(checkins[i]['checkin_name']);
				checkinDiv.find('input[name="checkin_count[]"]').val(checkins[i]['checkin_count']);
				checkinDiv.find('input[name="checkin_count_ladies[]"]').val(checkins[i]['checkin_count_ladies']);
				checkinDiv.find('input[name="checkin_count_minor[]"]').val(checkins[i]['checkin_count_minor']);
				checkinDiv.find('input[name="checkin_count_infant[]"]').val(checkins[i]['checkin_count_infant']);

				checkinDiv.find('input[name="checkin_phone_ignore[]"]').intlTelInput('setNumber', checkins[i]['checkin_phone']);
				checkinDiv.find('input[name="checkin_phone[]"]').val(checkins[i]['checkin_phone']);
				checkinDiv.find('input[name="checkin_city[]"]').val(checkins[i]['checkin_city']);
				checkinDiv.find('input[name="checkin_conveyance[]"]').val(checkins[i]['checkin_conveyance']);

				checkinDiv.find('select[name="in_out[]"]').val(checkins[i]['in_out']);

				updateDateTime(checkins[i]['created_at'], checkinDiv.find('.created_at_date input'));

				checkinDiv.find('input').each((index, el) => {
					if ($(el).attr('disabled') !== 'disabled') {
						$(el).attr('disabled', 'disabled');
						$(el).attr('data-disable-first', 'true');
					}
				});
				checkinDiv.find('.multi_field_add_btn').attr('data-disable-first', 'true');

				if (i !== checkins.length - 1) {
					checkinDiv.find('.multi_field_add_btn').trigger('click');
				}

				// checkinDiv.find('input').attr('disabled', 'disabled');

				// checkinDiv.find('.multi_field_add_btn').on('click', function (e: MouseEvent) {
				// 	if (!$(this).hasClass('btn-danger') && $(this).parent().parent().find('input[name="checkin_name[]"]').attr('disabled') === 'disabled') {
				// 		$(this)
				// 			.parent()
				// 			.parent()
				// 			.find('input')
				// 			.each((index: number, el: HTMLInputElement) => {
				// 				if (!$(el).hasClass('created_at_date')) {
				// 					$(el).removeAttr('disabled');
				// 				}
				// 			});
				// 	}

				// 	if ($(e.currentTarget).hasClass('btn-danger')) {
				// 	}
				// });
			}
		} else {
			if (
				(stateMap.checkinAllowed === false && Records.editAllowed === false) ||
				!record['card_no'] ||
				(record['approval'] && record['approval'].status !== 'Approved')
			) {
				sampleTile.find('.check-in-details').hide();
			}
		}

		configureRecordTypeAhead(sampleTile);
		// configurePhoneTypeAhead(sampleTile);

		sampleTile.find('input[name="phone"]').change(function () {
			sampleTile.find('.phone-detail .title').html('Mobile: ' + getInApp({ phone: $(this).val() }));
		});

		if (stateMap.checkinAllowed === false && Records.editAllowed === false) {
			sampleTile.find('.main-details .check-in-detail input').attr('disabled', 'disabled');
			sampleTile.find('.main-details .check-in-detail select').attr('disabled', 'disabled');
		} else {
		}

		if (!record['card_no'] || (record['approval'] && record['approval'].status !== 'Approved')) {
			sampleTile.find('.main-details .check-in-detail').css('pointer-events', 'none');
		}

		return sampleTile;
	}

	function updateDateTime(dateTime, el) {
		dateTime = dateTime.split(' ');
		var dateAr = dateTime[0].split('-');
		var date = new Date(parseInt(dateAr[0]), parseInt(dateAr[1]) - 1, parseInt(dateAr[2]));

		el.attr('value', dateTime[0]);
		el.datepicker('update', date);

		var time = dateTime[1];
		// var timeArr = time.split(':');
		// if (parseInt(timeArr[0]) > 12) {
		// 	time = parseInt(timeArr[0]) - 12 + ':' + timeArr[1] + ' PM';
		// } else {
		// 	time = time + ' AM';
		// }

		el.val(el.val() + ' ' + time);
	}

	function handleCheckins(tile) {
		Records.triggerEditRecord(tile);
	}


	return {
		initModule: initModule,
		disposeAutocomplete: () => {
			recordAutocomplete?.dispose();
			recordAutocomplete = undefined;
		},
		setConfig: function (key, value) {
			configMap[key] = value;
		},
		setRefFilter: (refs: string[]) => {
			stateMap.refFilter = refs;
			Records.refreshRecords();
		},
		setPinnedTiles: (pinnedTiles: { [id: string]: boolean }, refresh = true) => {
			stateMap.pinnedTiles = pinnedTiles ?? {};
			if (refresh) {
				Records.refreshRecords();
			}
		},
		/**
		 * Snapshots the records a bulk edit would touch, along with a readable description of
		 * the filters that produced them. The list is copied so a background refresh cannot
		 * change the target set between the preview and the run.
		 */
		getBulkEditContext: () => ({
			records: [...(Records.getCurrentRecords() ?? [])],
			filters: describeActiveFilters(),
			model: ModelClass.Instance(stateMap.systemId),
		}),
		refreshRecords: () => Records.refreshRecords(),
	};
})(jQuery);
